import { useEffect } from "react";
import socketService from "../store/api/socketService";

export const useSocket = (url: string, queryParams?: any) => {
    useEffect(() => {
        if (!socketService.getSocket())
            socketService.connect(url, queryParams);

        return () => {
            // socketService.disconnect();
        };
    }, []);

    return socketService;
};
